module.exports = __webpack_public_path__ + "img/sc-4.7e09b1b6.png";